<div *ngIf="receiverService.tabState && !tabsService.minimizeScreenMode">


  <form #form="ngForm" [ngClass]="['active',  tabsService.fullScreenMode ? 'fullscreen' : '']"
        autocomplete="off" >

    <div id="receiverList" class="fields__block" [style.width]="selectedReceiver == null ? '100%' : '50%'">
      <div class="fields__block__section">
        <app-grit-dynamic-table
          (selectedRowEvent)="showReceiver($event)"
          [entityName]="'Receiver'"
          [tableConfiguration]="ReceiverModel.configuration.table"
          [models]="receiverService.receiversSorted"
          [preSelected]="selectedReceiver?.id"
          [mode]="GritDynamicTableMode.SELECT"
          [type]="GritDynamicTableType.BASIC">
        </app-grit-dynamic-table>

        <h3 *ngIf="!receiverService.receivers || receiverService.receivers.length == 0">
          No receivers found!
        </h3>
      </div>
    </div>

    <fieldset *ngIf="selectedReceiver != null" id="receiverDetails" class="fields__block" style="max-height:100%; overflow: scroll"
              [disabled]="!this.gritUserService.allowedGroups(selectedReceiver.groupAccess, selectedReceiver.groupOriginator) ||
              !gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)">

      <div id="information" class="fields__block__section">

        <div class="title">
          <h4>Receivers Information</h4><span> </span>
        </div>

        <div class="input-fields">
          <div>
            <label for="name">Name</label>
            <input id="name" type="text" required minlength="0" maxlength="30"
                   [(ngModel)]="selectedReceiver.name" name="name"/>
          </div>
        </div>

        <div class="dropdown-fields">
          <div>
            <label for="deviceType">Device Type</label>
            <select id="deviceType" required
                    [(ngModel)]="selectedReceiver.deviceType" name="deviceType">
              <option *ngFor="let item of DeviceModel.fieldsValues.maintype"
                      [value]="item.value">{{item.display}}</option>
            </select>
          </div>

          <div>
            <label for="calculationUse">Use in Calculations</label>
            <select id="calculationUse" required
                    [(ngModel)]="selectedReceiver.calculationUse" name="calculationUse">
              <option [value]="true">{{'Yes'}}</option>
              <option [value]="false">{{'No'}}</option>
            </select>
          </div>
        </div>
      </div>

      <div id="technical" class="fields__block__section">
        <div class="title">
          <h4>Technical Specifications</h4><span> </span>
        </div>

        <div class="input-fields">
          <div>
            <label>Threshold Power</label>
            <div class="coordenates">
              <div>
                <input id="power_dBW" type="number" name="power_dBW" required
                       [(ngModel)]="selectedReceiver.threshold.dBW" style="width: 30%;"
                /><span>[dBW]</span>
                <input id="power_dBm" type="number" name="power_dBm" required
                       [(ngModel)]="selectedReceiver.threshold.dBm" style="width: 30%;"
                /><span>[dBm]</span>
              </div>
            </div>
          </div>

          <div>
            <label for="gain">Gain</label>
            <input id="gain" type="number" name="gain" required
                   [(ngModel)]="selectedReceiver.gain"
            /><span>[dBI]</span>
          </div>
        </div>
      </div>

      <grit-groups
        [(accessGroup)]="selectedReceiver.groupAccess"
        [(originatorGroup)]="selectedReceiver.groupOriginator"
        [(visibilityGroup)]="selectedReceiver.groupVisibility">
      </grit-groups>
    </fieldset>

    <div class="fields__btn">
      <ng-container *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)">
        <ng-container *ngIf="selectedReceiver != null &&
          this.gritUserService.allowedGroups(selectedReceiver.groupAccess, selectedReceiver.groupOriginator)">

          <button (click)="saveReceiver()" [disabled]="!form.form.valid || !groupsNotNull(selectedReceiver)" [ngClass]="form.form.valid && groupsNotNull(selectedReceiver) ? 'blue' : 'gray'">
            {{ selectedReceiver?.id == 0 ? 'Create' : 'Save'}}</button>

          <button (click)="deleteReceiver()" *ngIf="selectedReceiver?.id != 0" class="white">Delete</button>
        </ng-container>

        <button (click)="addReceiver()" *ngIf="selectedReceiver == null" class="blue" type="button" value="New">Add</button>
      </ng-container>

      <button (click)="selectedReceiver == null ? tabsService.closeTab() : selectedReceiver = null;" class="gray" type="button">Cancel</button>
    </div>
  </form>
</div>
